var randBool = require('./randBool');

    /**
     * Returns random bit (0 or 1)
     */
    function randomBit() {
        return randBool()? 1 : 0;
    }

    module.exports = randomBit;




//////////////////
// WEBPACK FOOTER
// ./~/mout/random/randBit.js
// module id = 1657
// module chunks = 0 1 2